
import FbxButton from './fbx-button.vue';
import { defineComponent, PropType } from 'vue';
import ReturnOptions from '@/components/ReturnOptions.vue';
import { lockBodyScroll, unlockBodyScroll } from '@/shared/bodyScrollLock';
import Trailer from '@/types/Trailer';

interface Data {
    selectedTrailerIndex: number | null;
}

export default defineComponent({
    props: {
        titleText: String,
        subheadingText: String,
        subtitleText: String,
        footerText: String,
        trailerOptions: {
            type: Object as PropType<Array<Trailer>>,
            required: true,
        },
        selectText: {
            type: String,
            default: 'Continue',
        },
        goBackText: {
            type: String,
            default: 'Go Back',
        },
        selectTheme: {
            type: String,
            default: 'primary',
        },
        goBackTheme: {
            type: String,
            default: 'return',
        },
        subtitleStyle: {
            type: String,
            default: 'subtitle-standard',
        },
        footerStyle: {
            type: String,
            default: 'bold',
        },
        popupStage: {
            type: Number,
            default: -1,
        },
        selectLoading: {
            type: Boolean,
            default: false,
        },
        goBackLoading: {
            type: Boolean,
            default: false,
        },
        fullScreen: {
            type: Boolean,
            default: true,
        },
        includeReturnDeepLink: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        boldTitle: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        FbxButton,
        ReturnOptions,
    },
    data(): Data {
        return {
            selectedTrailerIndex: null,
        };
    },
    methods: {
        goBackClicked(): void {
            this.$emit('goBack');
        },
        isSelected(index: number): boolean {
            return index === this.selectedTrailerIndex;
        },
        selectClicked(): void {
            this.$emit('select', {
                selectedTrailerIndex: this.selectedTrailerIndex,
            });
        },
        selectOption(index: number) {
            this.selectedTrailerIndex = index;
        },
    },
    computed: {
        UNKNOWN_TRAILER_SELECTION_INDEX: () => -1,
        selectDisabled(): boolean {
            return this.selectedTrailerIndex === null;
        },
    },
    created(): void {
        (document.activeElement as HTMLElement).blur();
    },
    beforeMount() {
        lockBodyScroll();
    },
    beforeUnmount() {
        unlockBodyScroll();
    },
});
